var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClipboardClock = function SvgClipboardClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipboard-clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#713F12",
    fillRule: "evenodd",
    d: "M5.65 8.304a3.641 3.641 0 0 0 .447 3.03H3.5A1.835 1.835 0 0 1 1.666 9.5V3.167c0-1.011.822-1.833 1.834-1.833h.183c.082-.565.564-1 1.15-1h2.333c.587 0 1.068.435 1.15 1H8.5c1.01 0 1.833.821 1.833 1.833V5.86a3.6 3.6 0 0 0-1.167-.194 3.67 3.67 0 0 0-3.23 1.935.5.5 0 0 0-.436-.269H4.166a.5.5 0 0 0 0 1H5.5a.5.5 0 0 0 .15-.03m-.817-6.97a.167.167 0 0 0-.167.166v.667c0 .092.075.167.167.167h2.333a.167.167 0 0 0 .167-.167V1.5a.167.167 0 0 0-.167-.167zm1.333 4h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1m.334 4a2.67 2.67 0 0 1 2.666-2.667 2.67 2.67 0 0 1 2.667 2.667A2.67 2.67 0 0 1 9.166 12 2.67 2.67 0 0 1 6.5 9.334m3.746.943a.499.499 0 0 0 .19-.963l-.77-.316v-.831a.5.5 0 0 0-1 0v1.167c0 .202.123.385.31.462l1.08.444a.5.5 0 0 0 .19.037",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipboard-clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgClipboardClock;